import { render } from "./DevicesTable.vue?vue&type=template&id=f478e834&scoped=true"
import script from "./DevicesTable.vue?vue&type=script&lang=js"
export * from "./DevicesTable.vue?vue&type=script&lang=js"

import "./DevicesTable.vue?vue&type=style&index=0&id=f478e834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f478e834"]])

export default __exports__